// extracted by mini-css-extract-plugin
export var viewButton = "ViewButton-module__viewButton___FUaIq";
export var viewButtonText = "ViewButton-module__viewButtonText___PCTK9";